import { translate } from "../../../../../../../services/translation.service";

export const helpLinksDictionary = [
  {
    getLabel: (): string => translate("footer.orderTracking"),
    getUrl: (): string => translate("links.orderTracking"),
  },
  {
    getLabel: (): string => translate("footer.faq"),
    getUrl: (): string => translate("links.faq"),
  },
];
